import * as React from 'react'
import GridItem from '../grid/GridItem'
import GridContainer from '../grid/GridContainer'
import CustomTabs from '../tab/CustomTabs'
import AddBoxIcon from '@material-ui/icons/AddBox'
import Parcels from './Parcels'
import ParcelTable from './ParcelTable'
import AllInboxIcon from '@material-ui/icons/AllInbox'

export default function ParcelTab() {
  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <CustomTabs
          headerColor="primary"
          tabs={[
            {
              tabName: 'Neues Paket',
              tabIcon: AddBoxIcon,
              tabContent: <Parcels />,
            },
            {
              tabName: 'Alle Pakete',
              tabIcon: AllInboxIcon,
              tabContent: <ParcelTable />,
            },
          ]}
        />
      </GridItem>
    </GridContainer>
  )
}
